import * as THREE from "three";

export function dampenAnimation(sourceClip, avatar, intensity) {
  if (!sourceClip || !avatar) {
    return null;
  }

  const newClip = sourceClip.clone();
  newClip.name = `${sourceClip.name}_dampened`;
  const newTracks = [];

  const restPose = new Map();
  avatar.traverse((node) => {
    if (node.isBone) {
      restPose.set(node.name, {
        position: node.position.clone(),
        quaternion: node.quaternion.clone(),
      });
    }
  });

  for (const track of sourceClip.tracks) {
    const [nodeName, property] = track.name.split(".");

    if (!restPose.has(nodeName)) {
      newTracks.push(track);
      continue;
    }

    const rest = restPose.get(nodeName);
    const newTrack = track.clone();
    const originalValues = newTrack.values;
    const newValues = new Float32Array(originalValues.length);

    if (property === "position") {
      const restValue = rest.position;
      for (let i = 0; i < originalValues.length; i += 3) {
        const originalVec = new THREE.Vector3().fromArray(originalValues, i);
        const newVec = new THREE.Vector3().lerpVectors(
          restValue,
          originalVec,
          intensity
        );
        newVec.toArray(newValues, i);
      }
    } else if (property === "quaternion") {
      const restValue = rest.quaternion;
      for (let i = 0; i < originalValues.length; i += 4) {
        const originalQuat = new THREE.Quaternion().fromArray(
          originalValues,
          i
        );
        const newQuat = new THREE.Quaternion().slerpQuaternions(
          restValue,
          originalQuat,
          intensity
        );
        newQuat.toArray(newValues, i);
      }
    } else {
      newValues.set(originalValues);
    }

    newTrack.values = newValues;
    newTracks.push(newTrack);
  }

  newClip.tracks = newTracks;
  return newClip;
}

export function createAdditiveAnimation(sourceClip) {
  if (!sourceClip) {
    return null;
  }

  const referencePose = sourceClip.clone();
  referencePose.tracks = referencePose.tracks.map((track) => {
    const newTrack = track.clone();
    newTrack.values = newTrack.values.slice(0, track.getValueSize());
    newTrack.times = new Float32Array([0]);
    return newTrack;
  });

  const additiveClip = sourceClip.clone();
  THREE.AnimationUtils.makeClipAdditive(additiveClip, 0, referencePose);
  additiveClip.name = `${sourceClip.name}_additive`;
  return additiveClip;
}
